export default __webpack_public_path__ + "static/media/RightQuotes.eea36569.svg";